import { TFunction } from 'i18next';

interface IUserIdentifiers {
  email?: string;
  mobilePhoneNumber?: string;
}

export interface IPasswordRule {
  key: string;
  test: (password: string, userIdentifiers?: IUserIdentifiers) => boolean;
}

export const getPasswordRules = (t: TFunction): IPasswordRule[] => [
  {
    key: 'createPassword.passwordMatcher.rules.length',
    test: pwd => pwd.length >= 8 && pwd.length <= 15,
  },
  {
    key: 'createPassword.passwordMatcher.rules.upperCase',
    test: pwd => /[A-Z]/.test(pwd),
  },
  {
    key: 'createPassword.passwordMatcher.rules.lowerCase',
    test: pwd => /[a-z]/.test(pwd),
  },
  {
    key: 'createPassword.passwordMatcher.rules.number',
    test: pwd => /\d/.test(pwd),
  },
  {
    key: 'createPassword.passwordMatcher.rules.special',
    test: pwd => /[!@#$%^&*(),.?":{}|<>]/.test(pwd),
  },
  {
    key: 'createPassword.passwordMatcher.rules.noSpaces',
    test: pwd => !/\s/.test(pwd) && pwd.length > 0,
  },
  {
    key: 'createPassword.passwordMatcher.rules.notUsername',
    test: (pwd, identifiers) => {
      if (!identifiers) return true;

      const password = pwd.toLowerCase();
      const { email, mobilePhoneNumber } = identifiers;

      // filter out empty identifiers and convert to lowercase
      const identifierValues = [email, mobilePhoneNumber].filter(Boolean).map(val => val.toLowerCase());

      // check whether the password matches any of the identifiers
      return (identifierValues.length === 0 || !identifierValues.includes(password)) && password?.length > 0;
    },
  },
];

export const validatePassword = (
  password: string,
  userIdentifiers?: IUserIdentifiers,
  rules?: IPasswordRule[],
): boolean => {
  if (!rules) return true;
  return rules.every(rule => rule.test(password, userIdentifiers));
};
